/** @jsxImportSource @emotion/react */
import { css} from '@emotion/react'
import { useEffect, useRef, useState } from 'react';
import { Button, DatePicker, Space, Spin, Switch, Table } from 'antd';
import dayjs from 'dayjs';
import moment from 'moment';
import EditRoundedIcon from '@mui/icons-material/EditRounded';

import axios from '../apiClient';
import Alert from '../alert';
import { useLocation, useNavigate } from 'react-router-dom';


// const data = [
//   {
//     id: 0,
//     name: 'Premier League',
//     children: [
//       {
//         id: 1,
//         name: 'John',
//       },
//       {
//         id: 1,
//         name: 'hello',
//       },
//     ],
//   },
//   {
//     id: 2,
//     name: 'jager League',
//     children: [
//       {
//         id: 100,
//         name: 'John Brown',
//         age: 42,
//         address: 'New York No. 2 Lake Park',
//       },
//       {
//         id: 3,
//         name: 'hello',
//         age: 42,
//         address: 'New York No. 2 Lake Park',
//       },
//     ],
//   },

// ];


const App = () => {
  const [date,setDate] = useState('')
  const [matchResults,setMatchResults] = useState([])
  const [loading,setLoading] = useState(true)
  const [settleStatementLoading,setSettleStatementLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [expandRowKeys, setExpandRowKeys] = useState([]);
  const [totalcompare, setTotalCompare] = useState(0);

  const confirmedHTMatches = useRef([])

  const navigate = useNavigate();
  const location = useLocation();

  const didMount = useRef(false)

  const columns = [
    {
      title: 'အမည်',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'ဘော်ဒီငွေ',
      dataIndex: 'totalHdpBetAmount',
      key: 'totalHdpBetAmount',
      align: 'right',
    },
    {
      title: 'ဂိုးပေါင်းငွေ',
      dataIndex: 'totalOuBetAmount',
      key: 'totalOuBetAmount',
      align: 'right',
    },
    {
      title: 'ငွေပေါင်း',
      dataIndex: 'totalBetAmount',
      key: 'totalBetAmount',
      align: 'right',
    },
    {
        title: 'အနိုင်',
        dataIndex: 'totalWinAmount',
        key: 'totalWinAmount',
        align: 'right',
      },
      {
        title: 'အရှုံး',
        dataIndex: 'totalLossAmount',
        key: 'totalLossAmount',
        align: 'right',
      },
    {
      title: 'ရပေး',
      dataIndex: 'compare',
      key: 'compare',
      align: 'right',
    },
  ];

  useEffect(()=>{
    if(location.state){
      setDate(location.state.date)
    }else{
      const today = moment().subtract(1,'day').format('DD-MM-YYYY');
      setDate(today)
    }
  },[])

  useEffect(()=>{
    if(didMount.current == true){
      const arr = matchResults.map(v=>v.key)
      setExpandRowKeys(arr)
    }
  },[matchResults])

  async function fetchData() {
    setLoading(true)
    let res = await axios.get(`/report/getStatements?startDate=${moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD')}&endDate=${moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD')}&type=single&current=1&pageSize=1000000`)
    console.log(res)

    if (res.code != 200) {
        if(res.code == 404){
            setLoading(false)
            setMatchResults([])
            return
        }
        setErrorMsg({ code: res.code, msg: res.message })
        setOpenAlert(true)
        setLoading(false)
        return
      }
      
    // const formattedData = res.data.map((vv,index) => {
    //     return {
    //       matchId: vv.matchId,
    //       settle: vv.current,
    //       name : vv.homeTeam.name_en + "-" + vv.awayTeam.name_en,
    //       id: index,
    //       matchDate : moment(vv.matchDate).format("DD-MM-YYYY h:mm A"),
    //       matchStatus : vv.status,
    //       firstHalfScore: vv.scores.halftime.home != null ? vv.scores.halftime.home + "-" + vv.scores.halftime.away : "-",
    //       secondHalfScore: vv.scores.fulltime.home != null ? (vv.scores.fulltime.home - vv.scores.halftime.home) + "-" + (vv.scores.fulltime.away -vv.scores.halftime.away) : "-",
    //       fullTimeScore : vv.scores.fulltime.home != null ? vv.scores.fulltime.home + "-" + vv.scores.fulltime.away : "-",
    //     }
      
    // })
    let temp=0
    res.data.by.map((v,i)=>{
      temp+=Number(v.compare.replace(/,/g, ""))
    })
    setMatchResults(res.data.by)
    temp=temp*(-1)
    setTotalCompare(temp.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }))
    setLoading(false)
  }
  
  useEffect(()=>{
    if(didMount.current){
      fetchData()
    }else{
      didMount.current = true
    }
  },[date])

  const handleEdit = (rowData) => navigate("/reports/matchResultEdit",{state: {rowData: rowData,date}})

  const handleDateChange = (value,dateString) => setDate(dateString)

  const handleCloseAlert = () => setOpenAlert(false)
  
  const handlePay = async () => {
    setSettleStatementLoading(true)
    let data = await axios.post(`/bet/setStatement`)
    setErrorMsg({ code: data.code, msg: data.message })
    setOpenAlert(true)
    setSettleStatementLoading(false)
  }

  const handleHTComfirm = async ({matchId}) => {
    let data = await axios.put(`/bet/updateMatchCalculate?matchId=${matchId}`)
    if(data.code == "200"){
      confirmedHTMatches.current.push(matchId);
    }
    setErrorMsg({ code: data.code, msg: data.message })
    setOpenAlert(true)
    fetchData()
  }


  return (
    <>
     <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
      <div style={{display: 'flex',justifyContent: 'space-between'}}>
      <div style={{display: 'flex',justifyContent: 'space-between',flexDirection:'row',}}>
      <Space
          align="center"
          style={{
            marginBottom: 16,
            marginRight:24
          }}
        >
           <DatePicker onChange={handleDateChange} format={'DD-MM-YYYY'} value={date ? dayjs(date,"DD-MM-YYYY") : ''}/>
        </Space>
        <h4 style={{fontWeight: "bold",color: "black"}}>{`ရပေးစုစုပေါင်း = ${totalcompare}`}</h4>
      </div>
        
        {/* <div>
          <Spin spinning={settleStatementLoading} size='small'>
          <Button disabled={!matchResults.some(v=> v.settle == "calculated")}  onClick={()=>handlePay()} style={{backgroundColor: "#c3ace6"}} css={css`color: black;border-color: "#4E6E81";:hover{border-color: "#4E6E81";color: black !important};`}  variant="outlined" >
              Settle Statements
          </Button>
          </Spin>
        </div> */}
      </div>
      <Table
        columns={columns}
        loading={loading}
        rowClassName = {(record,index)=> 'table-row-light-violet'}
        dataSource={matchResults}
        pagination={false}
        expandable={{expandRowByClick: false,expandIcon: ()=> null,expandedRowKeys: expandRowKeys}}
      />
    </>
  );
};
export default App;